export default {
  vipUpgrade: {
    title: 'बधाई हो!!',
    message: 'आपको VIP{from} से VIP{to} पर प्रमोट किया गया है',
    subtitle: 'आपके समर्थन के लिए धन्यवाद। आपके नए स्तर पर\nविशेष सेवाएँ और विशेषाधिकार मिलते हैं।',
    ok: 'OK'
  },
  settle: {
    loading: "Settling...",
    cannotEnterGame: "Your balance is being settled, please try again later.",
    blockedTitle: "Settling In Progress",
    blockedMsg: "Your balance is still being settled. Please wait a moment and try again."
  }
};
